import { BaseEnumEx } from './base-enum-ex'

// NOTE: Make sure this stays in sync with the server-side enum
export enum PurchaseOrderType {
    JobMaterial,
    Equipment,
    CreditCard,
    GeneralLedger,
}

export class PurchaseOrderTypeEx extends BaseEnumEx {
    public static toDisplay(item: PurchaseOrderType) {
        switch (item) {
            case PurchaseOrderType.JobMaterial:
                return 'Job Material'
            case PurchaseOrderType.Equipment:
                return 'Equipment'
            case PurchaseOrderType.CreditCard:
                return 'Credit Card'
            case PurchaseOrderType.GeneralLedger:
                return 'General Ledger'
        }
        return 'Unknown'
    }
}
